import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2, X } from "lucide-react";

const CancelSuccessModal = ({ open, onClose, policyNumber, providerName }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="flex fixed inset-0 z-50 justify-center items-center p-4"
        >
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 backdrop-blur-sm bg-black/40"
            onClick={onClose}
          />

          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.98 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="overflow-hidden relative z-10 w-full max-w-md bg-white rounded-2xl ring-1 ring-gray-100 shadow-2xl"
            role="dialog"
            aria-modal="true"
          >
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-emerald-500 via-green-500 to-emerald-500" />
            <div className="p-6">
              <div className="flex gap-3 items-start">
                <motion.div
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ type: "spring", stiffness: 220, damping: 18 }}
                  className="grid place-items-center w-11 h-11 text-white bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl shadow-lg"
                >
                  <CheckCircle2 size={22} />
                </motion.div>
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-gray-900">Policy cancelled</h3>
                  <p className="mt-1 text-sm text-gray-600">
                    Policy <span className="font-mono font-semibold text-gray-900">{policyNumber}</span>
                    {providerName ? (
                      <>
                        {" "}with <span className="font-semibold text-gray-900">{providerName}</span>
                      </>
                    ) : null} has been successfully cancelled.
                  </p>
                </div>
                <button
                  onClick={onClose}
                  className="grid place-items-center w-9 h-9 text-gray-500 rounded-lg hover:text-gray-700 hover:bg-gray-50"
                  aria-label="Close"
                >
                  <X size={18} />
                </button>
              </div>

              <div className="mt-5 w-full h-px bg-gradient-to-r from-transparent via-gray-100 to-transparent" />

              <div className="flex justify-end mt-4">
                <button
                  onClick={onClose}
                  className="inline-flex gap-2 items-center px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-emerald-600 to-green-700 rounded-xl shadow-md hover:from-emerald-700 hover:to-green-800 focus:outline-none focus:ring-2 focus:ring-emerald-400/50"
                >
                  Done
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CancelSuccessModal;


